import { Moment, duration, Duration } from 'moment';
import * as pluralize from 'pluralize';

export const formatDuration = (dur: Duration) => {
  const diffString = [];
  if (dur.months() > 0) {
    diffString.push(pluralize('month', dur.months(), true));
  }

  if (dur.days() > 0) {
    diffString.push(pluralize('day', dur.days(), true));
  }

  if (dur.hours() > 0) {
    diffString.push(pluralize('hour', dur.hours(), true));
  }

  if (dur.minutes() > 0) {
    diffString.push(pluralize('minute', dur.minutes(), true));
  }

  return diffString.join(' ');
};

export default function diffAsString(from: Moment, to: Moment): string {
  const dur = duration(to.diff(from));

  return formatDuration(dur);
}
